import React from 'react';
import { setup } from 'goober';
import { shouldForwardProp } from 'goober/should-forward-prop';
import useTheme from '../base/useTheme';
import '../assets/styles/main.scss';
import { installAiAgentChatColors } from '../components/chat/aiAgentChatColors';

export function init() {
    setup(
        React.createElement,
        undefined,
        useTheme,
        shouldForwardProp((prop) => {
            // props that start with `$` symbol will not be forwarded to dom
            return prop['0'] !== '$';
        })
    );
    installAiAgentChatColors();
}
